import axios, { AxiosInstance } from "axios";

import {
  API_BASE_URL_HTTP,
  API_TIMEOUT_IN_MS,
  IAxiosRequestWithRetryConfig,
  interceptors,
} from "@tm/api-utils";

const AXIOS_HTTP_CONFIG: IAxiosRequestWithRetryConfig = {
  baseURL: API_BASE_URL_HTTP,
  timeout: API_TIMEOUT_IN_MS,
  withCredentials: true,
  retry: 1,
};

if (process.env["NODE_ENV"] === "development" && process.env["PROXY_PORT"]) {
  AXIOS_HTTP_CONFIG.proxy = {
    protocol: "http:",
    host: "localhost",
    port: parseInt(`${process.env["PROXY_PORT"]}`),
  };
}

export const API_HTTP: AxiosInstance = axios.create(AXIOS_HTTP_CONFIG);

API_HTTP.interceptors.request.use(function (
  config: IAxiosRequestWithRetryConfig
) {
  config.headers = interceptors.enhanceRequestHeaders(config.headers);
  return config;
});

if (process.env["NODE_ENV"] === "development") {
  // API_HTTP.interceptors.response.use(function(value) {
  //     const {data} = value;
  //     console.dir({data}, {depth: 10})
  //     return value;
  // })
}

API_HTTP.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return interceptors.retryAxiosRequest(error, API_HTTP);
  }
);
